<script setup lang="ts">
type Props = {
  title?: string
  subtitle?: string
  image?: string
  text?: string
  imageSize?: string | number
}

const props = withDefaults(defineProps<Props>(), {
  imageSize: 50
})

type Slots = {
  title: string
  subtitle: string
  text: string
}

const slots = defineSlots<Slots>()
</script>

<template>
  <div class="info-section-tile__wrapper" v-orphans>
    <div
      class="info-section-tile"
      :class="{ 'info-section-tile--no-subtitle': !props.subtitle && !slots.subtitle }"
    >
      <v-img
        v-if="props.image"
        class="info-section-tile__image"
        :src="props.image"
        contain
        :width="props.imageSize"
        :height="props.imageSize"
      />
      <h4 v-if="props.title || slots.title" class="info-section-tile__title">
        <slot name="title">
          {{ props.title }}
        </slot>
      </h4>
      <h5 v-if="props.subtitle || slots.subtitle" class="info-section-tile__subtitle">
        <slot name="subtitle">
          {{ props.subtitle }}
        </slot>
      </h5>
      <p class="info-section-tile__text">
        <slot name="text">
          {{ props.text }}
        </slot>
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/assets/css/variables.scss' as variables;
@use 'sass:map';

.info-section-tile {
  &__wrapper {
    display: flex;
    justify-content: center;
    background-color: #fff;
  }

  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-areas:
    'image title'
    'image subtitle'
    'text text';
  gap: 8px;
  color: #424543;
  border-radius: 5px;
  padding: 8px 16px;
  width: 280px;

  @media screen and (min-width: map.get(variables.$grid-breakpoints, 'sm')) {
    padding: 32px 0;
    width: auto;
  }

  &--no-subtitle {
    grid-template-areas:
      'image title'
      'text text';
  }

  &__image {
    grid-area: image;
    align-self: center;
    margin-right: 16px;
  }

  &__title {
    grid-area: title;
    color: #ee6f66;
    align-self: center;
    font-size: 22px;
    font-weight: 500;
  }

  &__subtitle {
    grid-area: subtitle;
    align-self: center;
    font-size: 18px;

    @media screen and (min-width: map.get(variables.$grid-breakpoints, 'md')) {
      font-size: 22px;
    }
  }

  &__text {
    grid-area: text;
    font-size: 18px;

    @media screen and (min-width: map.get(variables.$grid-breakpoints, 'md')) {
      grid-column: 1 / -1;
    }
  }
}
</style>
